<template>
  <v-container>
    <v-flex md12>
      <div class="mb-4 headline text-xs-left font-weight-thin primary--text">
        {{ $t('TITLE_CONFIG_MODULE_' + this.idModule.toUpperCase())}}
      </div>
    </v-flex>
    <v-layout row wrap justify-space-between>
      <v-flex xs12 md5>
        <v-card dark tile flat color="white">
          <v-card-text class="headline text-xs-left font-weight-thin primary--text">
            {{ $t('TITLE_CONFIG_SEARCH_' + this.idModule.toUpperCase())}}
          </v-card-text>
          <v-layout justify-center>
            <v-flex xs10>
              <v-btn block @click="openSearchMaskConfig(moduleData.clientNr,-1)" class="my-4 text-none blue">
                {{'BTN_CONFIG_SEARCH' | translate}}
              </v-btn>
              <v-btn block @click="openHitListMaskConfig(moduleData.clientNr,-1)" class="my-4 text-none blue">
                {{'BTN_CONFIG_LIST' | translate}}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 md5>
        <v-card dark tile flat color="white">
          <v-card-text class="headline text-xs-left font-weight-thin primary--text">
            {{ $t('TITLE_CONFIG_PEERGROUP_' + this.idModule.toUpperCase())}}
          </v-card-text>
          <v-layout justify-center>
            <v-flex xs10>
              <v-btn block @click="openSearchMaskConfigPG(moduleData.clientNr,-1)" class="my-4 text-none blue">
                {{'BTN_CONFIG_SEARCH' | translate}}
              </v-btn>
              <v-btn block @click="openHitListMaskConfigPG(moduleData.clientNr,-1)" class="my-4 text-none blue">
                {{'BTN_CONFIG_LIST' | translate}}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 md5>
        <v-card dark tile flat color="white">
          <v-card-text class="headline text-xs-left font-weight-thin primary--text">
            {{ $t('TITLE_CONFIG_GLOBAL_SEARCH_' + this.idModule.toUpperCase())}}
          </v-card-text>
          <v-layout justify-center>
            <v-flex xs10>
              <v-btn block @click="openHitListGlobalSearchConfig(moduleData.clientNr,-1)" class="my-4 text-none blue">
                {{'BTN_CONFIG_LIST' | translate}}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

    </v-layout>
    <v-layout row wrap justify-space-between v-if="isAdmin">
      <v-flex xs12 md5>
        <v-card dark tile flat color="white">
          <v-card-text class="headline text-xs-left font-weight-thin primary--text">
            {{ $t('TITLE_CONFIG_SEARCH_ADMIN_' + this.idModule.toUpperCase())}}
          </v-card-text>
          <v-layout justify-center>
            <v-flex xs10>
              <v-btn block @click="openSearchMaskConfig(moduleData.clientNr,10)" class="my-4 text-none blue">
                {{'BTN_CONFIG_SEARCH' | translate}}
              </v-btn>
              <v-btn block @click="openHitListMaskConfig(moduleData.clientNr,10)" class="my-4 text-none blue">
                {{'BTN_CONFIG_LIST' | translate}}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 md5>
        <v-card dark tile flat color="white">
          <v-card-text class="headline text-xs-left font-weight-thin primary--text">
            {{ $t('TITLE_CONFIG_PEERGROUP_ADMIN_' + this.idModule.toUpperCase())}}
          </v-card-text>
          <v-layout justify-center>
            <v-flex xs10>
              <v-btn block @click="openSearchMaskConfigPG(moduleData.clientNr,10)" class="my-4 text-none blue">
                {{'BTN_CONFIG_SEARCH' | translate}}
              </v-btn>
              <v-btn block @click="openHitListMaskConfigPG(moduleData.clientNr,10)" class="my-4 text-none blue">
                {{'BTN_CONFIG_LIST' | translate}}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 md5>
        <v-card dark tile flat color="white">
          <v-card-text class="headline text-xs-left font-weight-thin primary--text">
            {{ $t('TITLE_CONFIG_GLOBAL_SEARCH_ADMIN_' + this.idModule.toUpperCase())}}
          </v-card-text>
          <v-layout justify-center>
            <v-flex xs10>
              <v-btn block @click="openHitListGlobalSearchConfig(moduleData.clientNr,10)" class="my-4 text-none blue">
                {{'BTN_CONFIG_LIST' | translate}}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-space-between v-if="isSuperAdmin">
      <v-flex xs12 md5>
        <v-card dark tile flat color="white">
          <v-card-text class="headline text-xs-left font-weight-thin primary--text">
            {{ $t('TITLE_CONFIG_SEARCH_SADMIN_' + this.idModule.toUpperCase())}}
          </v-card-text>
          <v-layout justify-center>
            <v-flex xs10>
              <v-btn block @click="openSearchMaskConfig(463,10)" class="my-4 text-none blue">
                {{'BTN_CONFIG_SEARCH' | translate}}
              </v-btn>
              <v-btn block @click="openHitListMaskConfig(463,10)" class="my-4 text-none blue">
                {{'BTN_CONFIG_LIST' | translate}}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 md5>
        <v-card dark tile flat color="white">
          <v-card-text class="headline text-xs-left font-weight-thin primary--text">
            {{ $t('TITLE_CONFIG_PEERGROUP_SADMIN_' + this.idModule.toUpperCase())}}
          </v-card-text>
          <v-layout justify-center>
            <v-flex xs10>
              <v-btn block @click="openSearchMaskConfigPG(463,10)" class="my-4 text-none blue">
                {{'BTN_CONFIG_SEARCH' | translate}}
              </v-btn>
              <v-btn block @click="openHitListMaskConfigPG(463,10)" class="my-4 text-none blue">
                {{'BTN_CONFIG_LIST' | translate}}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 md5>
        <v-card dark tile flat color="white">
          <v-card-text class="headline text-xs-left font-weight-thin primary--text">
            {{ $t('TITLE_CONFIG_GLOBAL_SEARCH_SADMIN_' + this.idModule.toUpperCase())}}
          </v-card-text>
          <v-layout justify-center>
            <v-flex xs10>
              <v-btn block @click="openHitListGlobalSearchConfig(463,10)" class="my-4 text-none blue">
                {{'BTN_CONFIG_LIST' | translate}}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Config.vue',
  components: {},
  methods: {
    openHitListMaskConfig: function (clientNr, userId) {
      this.$router.push('/di/Konfiguration/' + this.idModule + '/Trefferliste/Anker/' + userId + '/' + clientNr)
    },
    openSearchMaskConfig: function (clientNr, userId) {
      this.$router.push('/di/Konfiguration/' + this.idModule + '/Suchmaske/Anker/' + userId + '/' + clientNr)
    },
    openHitListGlobalSearchConfig: function (clientNr, userId) {
      this.$router.push({
        path: '/di/Konfiguration/' + this.idModule + '/Trefferliste/GlobalSearch/' + userId + '/' + clientNr
      })
    },
    openHitListMaskConfigPG: function (clientNr, userId) {
      this.$router.push({
          path: '/di/Konfiguration/' + this.idModule + '/Trefferliste/Peergroup/' + userId + '/' + clientNr
        })
    },
    openSearchMaskConfigPG: function (clientNr, userId) {
      this.$router.push({
          path: '/di/Konfiguration/' + this.idModule + '/Suchmaske/Peergroup/' + userId + '/' + clientNr
        })
    }
  },
  data () {
    return {
      crumps: [],
      isAdmin: false,
      isSuperAdmin: false,
      idModule: '',
      moduleData: {}
    }
  },
  mounted () {
    this.moduleData = Vue.prototype.$api.getParamData()
    Vue.prototype.$api.debug('Module Config', this.$route.params, this.moduleData)
    this.idModule = this.$route.params.idModule
    this.idModuleItem = this.$route.params.idModuleItem
    this.crumps = Vue.prototype.$api.getBreadCrumpModule(this.idModule)
    this.isAdmin = Vue.prototype.$api.isAdmin()
    this.isSuperAdmin = Vue.prototype.$api.isSuperAdmin()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/Config.vue